import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Product} from '../model/Entities/Product';
import {Observable} from 'rxjs/Observable';
import {User} from '../model/Entities/User';
import {Availability} from '../model/Entities/Availability';
import {Contract} from '../model/Entities/Contract';
import {ProductContractItem} from '../model/Entities/ProductContractItem';

@Injectable()
export class AvailabilityService extends ApiService<Availability> {

    protected apiUrl = 'api/availability';  // URL to web api

    protected getObjectType(): any {
        return Availability;
    }

    public getAvailability(ci: ProductContractItem, count: number, from: Date,
                           to: Date = null, contract: Contract = null): Observable<Availability> {
        const params: any = {
            'product_id': ci.productId,
            'contract_item_id': ci.id,
            'count': count,
            'from': from.toISOString(),
        };

        if (to) {
            params.to = to.toISOString();
        }

        if (contract) {
            params.exclude_contracts = contract.id;
        }

        return this.sendGet(`${this.apiRoot}/${this.apiUrl}`, params);
    }
}



// WEBPACK FOOTER //
// /app/src/services/availability.service.ts